import { render, staticRenderFns } from "./FeaturedCollectionHost.vue?vue&type=template&id=fda16ac8"
import script from "./FeaturedCollectionHost.vue?vue&type=script&lang=js"
export * from "./FeaturedCollectionHost.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports